export function getSummaryMetric(value: unknown, percentage: boolean): number | null {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) return null;
  return (percentage ? value <= 100 : Number.isInteger(value)) ? value : null;
}
